<template>
    <div class="p-3">
        <legend>Ошибки</legend>
        <ul class="list-unstyled">
            <li v-for="error in errors" v-html="error"></li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'ErrorModal',
  props: {
    errors: Array,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
